import { render, staticRenderFns } from "./SidebarPopover.vue?vue&type=template&id=19d82595"
import script from "./SidebarPopover.vue?vue&type=script&lang=js"
export * from "./SidebarPopover.vue?vue&type=script&lang=js"
import style0 from "./SidebarPopover.vue?vue&type=style&index=0&id=19d82595&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports